// Honest framing for the globalOutlook scores.
//
// demandScore and aiResilienceScore are AI-derived ESTIMATES from embedded
// McKinsey/WEF automation data. They are not precisely measured metrics.
// Showing them as "78%" or "82/100" implies a precision we do not have and
// a sharp counselor or parent will (rightly) distrust it.
//
// These helpers collapse the raw 0-100 number into an honest qualitative
// band for display. The raw number is still fine to use for relative bar
// widths (a bar is obviously approximate); only the literal number text is
// the credibility problem.

export type OutlookBand = 'Higher' | 'Moderate' | 'Lower' | 'Strong' | 'Soft';

export const resilienceBand = (score: number): 'Higher' | 'Moderate' | 'Lower' =>
  score >= 70 ? 'Higher' : score >= 45 ? 'Moderate' : 'Lower';

export const demandBand = (score: number): 'Strong' | 'Moderate' | 'Soft' =>
  score >= 75 ? 'Strong' : score >= 50 ? 'Moderate' : 'Soft';

// Display strings used across results surfaces (screen + PDF) so the
// wording is identical everywhere.
export const resilienceLabel = (score: number): string =>
  `${resilienceBand(score)} AI resilience`;

export const demandLabel = (score: number): string =>
  `${demandBand(score)} demand`;
